import type { User, UserId } from 'features/users/types';
import { call, put, select } from 'redux-saga/effects';
import { selectActiveUserById, selectLocalUserId } from 'features/users/usersSlice';
import { eventBus } from 'utils/eventBus';
import { raiseHandNotificationUpdateRequested } from 'features/notifications/actions';
import { signalingHandRaised } from 'features/users/actions';

export function* onHandRaisedSaga({
  payload: {
    initiator: { id: initiatorId },
  },
}: ReturnType<typeof signalingHandRaised>) {
  yield call(eventBus.sendMessage, 'handRaised', { userId: initiatorId });

  // skip notification for the initiator
  const localUserId: UserId = yield select(selectLocalUserId);
  if (localUserId === initiatorId) {
    return;
  }

  const initiatorUser: User | undefined = yield select(selectActiveUserById, initiatorId);
  if (!initiatorUser) {
    return;
  }

  yield put(raiseHandNotificationUpdateRequested({ reason: 'hand-raised' }));
}
